/*----------------------------------
- TLD PAGES: PERSONA CARD
----------------------------------*/

/**
 * @docs docs/features/tld-intelligence
 * @adr  ADR-0062
 * @rule One persona card for the hub and every insight page: the same words
 *       (`TLD_PAGE_CONTENT.personas`) and markup, each page passing its own triggers, section,
 *       surface and signup attribution, so the two cards cannot drift.
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import type { ConversionTriggerId } from '@uniquedomains/components/contracts/analytics/conversionTriggers';

import { TLD_PAGE_CONTENT } from '@/client/catalogs/landing/tld/pageContent';
import PersonaAuthCtaPair from '@/client/pages/landing/components/conversion/PersonaAuthCtaPair';
import { CARD_BODY_CLASS, CARD_TITLE_CLASS, WHITE_CARD_CLASS } from '@/client/pages/landing/components/shared/pageStyles';

/*----------------------------------
- TYPES
----------------------------------*/

type TldPersonasCardProps = {
    testId: string;
    /** Signup attribution of both CTAs (`User.desiredFrom`). */
    attribution: string;
    investorTriggerId: ConversionTriggerId;
    founderTriggerId: ConversionTriggerId;
    trackingPage: string;
    section: string;
    surface: string;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

export default function TldPersonasCard({ testId, trackingPage, ...pair }: TldPersonasCardProps) {
    const content = TLD_PAGE_CONTENT.personas;
    return (
        <section data-testid={testId}>
            <div class={`${WHITE_CARD_CLASS} flex flex-col gap-3 p-5 lg:flex-row lg:items-center lg:justify-between lg:p-8`}>
                <div class="max-w-[640px]">
                    <h2 class={CARD_TITLE_CLASS}>{content.heading}</h2>
                    <p class={`${CARD_BODY_CLASS} mt-2`}>{content.body}</p>
                </div>
                <div class="flex flex-wrap gap-3">
                    <PersonaAuthCtaPair {...pair} page={trackingPage} size="md" tone="light" />
                </div>
            </div>
        </section>
    );
}
